<kgr-confirmation-modal
  [show]="show$ | async"
  headline="Push Benachrichtigungen"
  i18n-headline
  cancelButtonLabel="Später"
  i18n-cancelButtonLabel
  [showDeclineButton]="true"
  (cancelConfirmation)="onCancel()"
  (confirmConfirmation)="onConfirm()"
  (declineConfirmation)="onDecline()"
>
  <ng-container *kgrIfInstitutionType="'club'">
    <div i18n class="kgr-row">
      Dürfen wir dir Push-Nachrichten schicken, damit du keine wichtigen Neuigkeiten aus deinem Verein verpasst?
    </div>

    @if (showPermissionNotGrantedHint()) {
      <div class="kgr-alert kgr-alert--warning" i18n>Bitte gib der App die Berechtigung, Push Benachrichtigungen zu versenden.</div>
    }
  </ng-container>
  <ng-container *kgrIfInstitutionType="'kindergarten'">
    <div i18n class="kgr-row">
      Dürfen wir Ihnen Push-Benachrichtigungen senden, damit Sie keine wichtigen Neuigkeiten aus Ihrer Einrichtung verpassen?
    </div>

    @if (showPermissionNotGrantedHint()) {
      <div class="kgr-alert kgr-alert--warning" i18n>Bitte gib der App die Berechtigung, Push Benachrichtigungen zu versenden.</div>
    }
  </ng-container>
</kgr-confirmation-modal>
